import {
  Avatar,
  Box,
  Button,
  Card,
  ComponentTrackingType,
  Flex,
  Heading,
  Icon,
  IconButton,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setDefaultAffordabilityMethod, toggleAffordabilityModal } from '../../../actions'
import { selectAffordability, selectBuyerIsPrequal } from '../../../store/selectors/affordability'
import { selectLoanOfficerPhotoUri } from '../../../store/selectors/loanOfficer'
import Format from '../../shared/Format'

const MSG = defineMessages({
  prequal: {
    id: 'Affordability.prequal',
    defaultMessage: 'Pre-Qual'
  },
  change: {
    id: 'Affordability.pricePoint.changeButton',
    defaultMessage: 'Change'
  },
  budget: {
    id: 'Affordability.pricePoint.yourPricePoint',
    defaultMessage: 'Budget'
  }
})

export interface PricePointProps {
  'data-qa'?: string
  hideCardBg?: boolean
  minimal?: boolean
  onClick?: () => void
  buttonTracking?: ComponentTrackingType
}

export const PricePoint = ({
  'data-qa': dataQa,
  minimal,
  hideCardBg = false,
  onClick,
  buttonTracking
}: PricePointProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isPrequal = useSelector(selectBuyerIsPrequal)
  const avatarUrl = useSelector(selectLoanOfficerPhotoUri)
  const affordabilityAmount = useSelector(selectAffordability)

  const handleEdit = () => {
    // wait for the drawer to close before opening modal so there's no clash in focus states
    setTimeout(() => {
      dispatch(setDefaultAffordabilityMethod())
      dispatch(toggleAffordabilityModal())
    }, 200)
    onClick && onClick()
  }

  const PricePointBody = (
    <Flex
      gap={2}
      padding={minimal ? '' : '4'}
      display='flex'
      data-qa={dataQa}
      alignItems='center'
      justifyContent='space-between'
    >
      <Flex gap={2} align='center'>
        {isPrequal && <Avatar size='sm' src={avatarUrl} />}
        <Box>
          <Heading size='2xs' textAlign='left' marginBottom={0} variant='eyebrow' whiteSpace='nowrap'>
            {intl.formatMessage(isPrequal ? MSG.prequal : MSG.budget)}
          </Heading>
          <Flex align='center' gap={1}>
            <Text color='success' marginBottom={0} size={hideCardBg ? 'md' : 'lg'}>
              <Format.Currency value={affordabilityAmount} />
            </Text>
            {hideCardBg && (
              <IconButton
                size='sm'
                variant='ghost'
                colorScheme='primary'
                onClick={handleEdit}
                icon={<Icon name='wrench' />}
                aria-label={intl.formatMessage(MSG.change)}
                tracking={{
                  ...buttonTracking,
                  descriptor: MSG.change.defaultMessage
                }}
              />
            )}
          </Flex>
        </Box>
      </Flex>
      <Box>
        {!hideCardBg && (
          <Button
            size='sm'
            onClick={handleEdit}
            width={20}
            tracking={{
              ...buttonTracking,
              descriptor: MSG.change.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.change)}
          </Button>
        )}
      </Box>
    </Flex>
  )

  if (minimal || hideCardBg) {
    return PricePointBody
  }

  return (
    <Card size='lg' flex='1 1 auto' maxWidth='25rem'>
      {PricePointBody}
    </Card>
  )
}
